
import React from "react";
import { RecruitmentKPIs } from "../components/RecruitmentKPIs";
import { EnhancedCard } from "../components/enhanced/EnhancedCard";
import { TrendingUp } from "lucide-react";
import type { Candidate } from "@/components/candidates/types";

interface KPISectionProps {
  candidates: Candidate[];
}

export const KPISection = ({ candidates }: KPISectionProps) => {
  return (
    <EnhancedCard
      title="Key Performance Indicators"
      description="Overview of your recruitment metrics"
      icon={<TrendingUp className="h-5 w-5" />}
      className="mb-8"
    >
      <RecruitmentKPIs candidates={candidates} />
    </EnhancedCard>
  );
};
